<template>
  <div data-css-scope="quasar" :class="bodyClasses">
    <QCheckbox v-bind="$attrs" v-model="model" @update:model-value="model = $event" ref="qRef"></QCheckbox>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script lang="ts" setup>
import { defineExpose, onMounted, ref } from 'vue';
const qRef = ref();
const bodyClasses = ref();
const possibleClasses = [
  'body--dark',
  'body--light',
  'desktop',
  'mobile',
  'touch',
  'no-touch',
  'platform-android',
  'platform-ios',
  'native-mobile',
  'electron',
  'bex',
  'within-iframe',
];
interface Props {
  modelValue: any,
}
const props = defineProps<Props>();
const model = ref(!!props.modelValue);

onMounted(() => {
  const classList = Array.from(document.body.classList);
  bodyClasses.value = classList.filter(value => possibleClasses.includes(value));
});

const exposed = {};
const methods = [
  'toggle',
];
methods.forEach((methodName) => {
  const proxyFunction = (...params) => {
    return qRef.value[methodName](...params);
  }
  exposed[methodName] = proxyFunction;
})
defineExpose(exposed)
</script>

<style lang="scss" scoped>
@import "../../core/typography";
::v-deep(.q-checkbox) {
  align-items: flex-start;
  .q-checkbox__inner {
    margin-left: -10px;
  }
  .q-checkbox__bg {
    top: 27.5%;
    left: 27.5%;
    width: 45%;
    height: 45%;
  }
  .q-checkbox__label {
    @include font-metrics;
    --font-weight: 500;
    --font-size: 13;
    --line-height: 1.15;
    --color: var(--mc-2022-typography-heading-color);
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 6px 0 6px 4px;
  }
}
</style>
